import React from 'react';
import * as Ui from './styles';

export function Footer() {
  return (
    <Ui.Footer>
    </Ui.Footer>
  );
}
